<div [id]="getId()" class="modal fade modal-lg" role="dialog" tabindex="-1">
    <div class="modal-dialog">

        <div class="modal-content">

            <div class="modal-header">
                <button class="btn-close" data-bs-dismiss="modal" title="Schließen" type="button"></button>
            </div>

            <div class="modal-body">
                <app-last-used-books></app-last-used-books>
                <a [href]="applicationStateService.bookConfig.listLink" class="btn btn-round btn-open btn-semibold">
                    Alle Bücher
                </a>
                @if (seriesBooks && seriesBooks.length > 0) {
                    <h4 class="mt-5 mb-2">Weitere Bücher aus dieser Reihe</h4>
                    <ul>
                        @for (seriesBook of seriesBooks; track seriesBook) {
                            <li>
                                <a [href]="seriesBook.url">
                                    <div class="title">
                                        @if (seriesBook.cover) {
                                            <img [alt]="'Buchcover von ' + seriesBook.title"
                                                 [src]="seriesBook.cover"/>
                                        }
                                        <div>{{ seriesBook.title }}</div>
                                    </div>
                                    <div class="meta">
                                        <div class="edition">{{ seriesBook.edition }}
                                            /<strong>{{ seriesBook.editionyear }}</strong></div>
                                        <div class="isbn">{{ seriesBook.isbn }}</div>
                                    </div>
                                </a>
                            </li>
                        }
                    </ul>
                }
            </div>
        </div>
    </div>
</div>
